var React = require('react');
var ReactDOM = require('react-dom');
var ReactRouter = require('react-router');
var ReactRouterRedux = require('react-router-redux');
var ReactRedux = require('react-redux');
var firebase = require('./firebase');
var getRoutes = require('./routes');
var store = require('./store');
var authActions = require('./actions/authActions');
var moment = require('moment');
var AuthInfo = require('./helpers/AuthInfo');

var { Router, browserHistory } = ReactRouter;
var { syncHistoryWithStore } = ReactRouterRedux;
var { Provider } = ReactRedux;
var { fbAuth } = firebase;

var history = syncHistoryWithStore(browserHistory, store);

require('moment-duration-format');
require('bootstrap/dist/css/bootstrap.css');
require('flexboxgrid/dist/flexboxgrid.css');
require('./libs/fontello/css/fontello.css');
require('toastr/build/toastr.css');
require('./index.css');

moment.locale('pt-BR');

function onAuthChange(dispatch) {
  return new Promise((resolve, reject) => {
	const unsub = fbAuth.onAuthStateChanged(
	  user => {
		dispatch(authActions.onAuthChange(user));
		unsub();
		resolve();
	  },
	  error => reject(error)
	);
  });
}

onAuthChange(store.dispatch)
.then(() => {
	AuthInfo.storeUser(fbAuth.currentUser);

	ReactDOM.render(
		<Provider store={store}>
			<Router routes={getRoutes(store.getState)} history={history}/>
		</Provider>,
		document.getElementById('root')
	)
}).catch(error => console.error(error)); // eslint-disable-line no-console*/

/*ReactDOM.render(
	<Provider store={store}>
		<Router routes={getRoutes(store.getState)} history={history}/>
	</Provider>,
	document.getElementById('root')
);*/


// WEBPACK FOOTER //
// ./src/index.js